import { pbufMapDecoder } from '../decoder/map';
import { TsMap, pbufTsMapDecoder } from '../decoder/tsmap';
var MapStationLoader = /** @class */ (function () {
    function MapStationLoader(auth) {
        this.auth = auth;
        this.fetchSpeciePromises = {};
        this.stationsGeo = {};
        this.firstLoading = true;
        // this.prefetch('pm25', 'pm10', 'o3', 'o3_8', 'no2', 'so2', 'co')
    }
    MapStationLoader.prototype.prefetch = function () {
        var _this = this;
        var species = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            species[_i] = arguments[_i];
        }
        if (species.length == 0)
            return;
        this.fetch(species[0]).then(function () {
            _this.prefetch.apply(_this, species.slice(1));
        });
    };
    MapStationLoader.prototype.fetch = function (specie) {
        var _this = this;
        var p = this.fetchSpeciePromises[specie];
        if (p)
            return p;
        var action = this.firstLoading ? 'stations' : 'aqi';
        this.firstLoading = false;
        var url = 'map/' + action + '/' + specie + '.pbf';
        p = this.auth.fetchPBUF(url, pbufMapDecoder);
        if (action == 'stations')
            p = p.then(function (map) {
                map.feeds.forEach(function (feed) {
                    feed.stations.forEach(function (s) {
                        var key = feed.name + '/' + s.stationIdx;
                        _this.stationsGeo[key] = s.geo;
                    });
                });
                return map;
            });
        else
            p = p.then(function (map) {
                map.feeds.forEach(function (feed) {
                    feed.stations.forEach(function (s) {
                        var key = feed.name + '/' + s.stationIdx;
                        s.geo = _this.stationsGeo[key];
                    });
                });
                return map;
            });
        this.fetchSpeciePromises[specie] = p;
        return p;
    };
    MapStationLoader.prototype.fetchHistoric = function (specie) {
        var url = 'map/historic/' + specie + '.pbf';
        return this.auth.fetchPBUF(url, pbufTsMapDecoder).then(function (map) {
            return new TsMap(map);
        });
    };
    return MapStationLoader;
}());
export { MapStationLoader };
